export default class AddPRILCommentPayload {
  comment!: string;
}
